import videojs from "video.js";
// Plugins must load after video.js
import "@videojs/http-streaming";
import "videojs-contrib-eme";

import { createFragment } from "../utilities/elements.js";
import { DickTokStandaloneComponent } from "./StandaloneComponent.js";
import { defineElement } from "./registry.js";

export class VideoDetect extends DickTokStandaloneComponent {
  static services = ["LoggingService", "SessionApiService"];

  static template = createFragment`
    <div class="dt-videodetect__container">
      <div>
        <i class="fa-sharp fa-solid fa-spinner-third fa-spin fa-6x"></i>
      </div>
    </div>`;

  connectedCallback() {
    super.connectedCallback();
    this.#detectSupport();
  }

  async #detectSupport() {
    // Create a temporary video element to check native HLS/DASH support
    const video = document.createElement("video");

    // 1. Check for native HLS support
    const nativeHlsSupport =
      video.canPlayType &&
      video.canPlayType(
        'application/vnd.apple.mpegurl; codecs="avc1.64001e, mp4a.40.2"',
      ) === "probably";

    // 2. Check for native DASH support
    const nativeDashSupport = !!(
      video.canPlayType &&
      video.canPlayType(
        'application/dash+xml; codecs="avc3.42c029, mp4a.40.2"',
      ) !== "probably"
    );

    // 3. Check for Video.js HLS support (VHS polyfill)
    const videojsHlsSupport =
      videojs
        .getTech("Html5")
        .canPlayType(
          'application/vnd.apple.mpegurl; codecs="avc1.64001e, mp4a.40.2"',
        ) === "probably";

    // 4. Check for Video.js DASH support (VHS polyfill)
    const videojsDashSupport =
      videojs
        .getTech("Html5")
        .canPlayType(
          'application/dash+xml; codecs="avc3.42c029, mp4a.40.2"',
        ) === "probably";

    let format;
    if (nativeHlsSupport || videojsHlsSupport) {
      format = "HLS";
    } else if (nativeDashSupport || videojsDashSupport) {
      format = "DASH";
    } else {
      throw new Error("No video support detected");
    }

    const response = this.sessionApiService.setFormat(format);
    // This will not work and I dont have any idea why right now and I don't
    // have time to fix it.
    this.loggingService.log("Redirect path: ", response.redirectPath);
    window.location.href = "/"; //response.redirectPath;
  }
}

defineElement("dt-videodetect", VideoDetect);
